<template>
  <div class="content-wrapper">
    <app-breadcrumb
      :page-title="$t('Procesos de ')"
      :directory="$t('acreditación')"
      :icon="'trello'"
    />
    <div class="mb-primary">
      <app-note
        class="pt-2 clearfix"
        :title="$t('Seleccione el cliente')"
        content-type="html"
        note-type="note-warning"
        :notes="[$t('Y consulte el estado de los procesos en curso')]"
      />
    </div>

    <div class="mb-primary">
      <form
        ref="form"
        data-url="/crud"
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
      >
        <div class="row">
          <div class="col-4">
            <div class="form-group mb-2 mb-md-0">
              <label>{{ $t("Seleccionar un OEC") }}</label>
              <app-input
                type="select"
                v-model="inputs.status"
                :list="statusLists"
              />
            </div>
          </div>
          <div class="col-2">
            <div class="form-group mb-2 mb-md-0">
              <br />
              <app-button
                :label="$t('Buscar')"
                class-name="btn-primary mr-2 mb-2 mb-sm-0"
                :is-disabled="false"
                @submit="submit"
              />
            </div>
          </div>
        </div>
      </form>
      <br />
      <app-table v-if="showTable" :id="tableId" :options="options" @action="getListAction" />
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  name: "FormGrid",
  mixins: [FormMixin, TableHelpers],
  data() {
    return {
      preloader: false,
      showTable: false,
      inputs: {
        gender: "male",
      },
      statusLists: [
        { id: "", value: "Selecciona una" },
        { id: "active", value: "ACRETI S.A." },
      ],

      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "pending-list",
      rowData: {},
      options: {
        url: `${actions.ACCREDITATIONREVIEW}/index`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Ver"),
            icon: "edit",
            type: "none",
            component: "deposit-modal",
            modalId: "deposit-add-edit-modal",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },

  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    submit() {
      this.showTable = true;
    },
    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#deposit-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    /**
     * $emit form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("Ver")) {
        this.selectedUrl = `${actions.ACCREDITATIONREVIEW}/${rowData.id}`;
        this.openAddEditModal();
        // window.location = `${actions.ACCREDITATIONREVIEW}/${this.rowData.id}`;
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit form confirmation modal
     */
    confirmed() {
      let url = `${actions.ACCREDITATIONREVIEW}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#pending-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    data() {
      this.preloader = true;
      let url = `${actions.ACCREDITATIONREVIEW}/index`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.accreditationAreaList = [
              { id: "", value: this.$t("select_option") },
              ...response.data.accreditationAreas,
            ];
            this.accreditationActivityList = [
              { id: "", value: this.$t("select_option") },
              ...response.data.accreditationActivities,
            ];
            this.accreditationTypeList = [
              { id: "", value: this.$t("select_option") },
              ...response.data.accreditationTypes,
            ];
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
